/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import Select from 'react-select';
import { compose, graphql } from 'react-apollo';
import { storeRoles, deleteStoreRole } from '../../../../queries';
import VerifyRoleFormModal from '../../../../components/Modal/Store/Account/Role/Verify';
import ConfirmRoleFormModal from '../../../../components/Modal/Store/Account/Role/Confirm';
import NewRoleFormModal from '../../../../components/Modal/Store/Account/Role/New';
import EditRoleFormModal from '../../../../components/Modal/Store/Account/Role/Edit';
import Loading from '../../../../components/Loading/Page';

import ListItem from './Item';

import { Content, Button } from './styles';
import { Row, Label, SelectLabel } from '../../../../assets/styles';

class AdminRoles extends Component {
  state = {
    options: [
      { value: '001', label: 'Dono' },
      { value: '002', label: 'Gerente' },
      { value: '003', label: 'Funcionário' },
    ],
    role: 'Funcionário',
    verifyRoleFormModal: false,
    confirmRoleFormModal: false,
    newRoleFormModal: false,
    editRoleFormModal: false,
  };

  componentDidMount = () => {
    if (this.props.user.roleType === 'manager') {
      this.setState({ options: [{ value: '003', label: 'Funcionário' }] });
    }
  }

  openVerifyRoleFormModal = () => {
    const { role } = this.state;

    this.verifyRoleFormModal.openVerifyRoleFormModal(role);
    this.setState({ verifyRoleFormModal: true });
  };

  closeVerifyRoleFormModal = () => {
    this.setState({ verifyRoleFormModal: false });
  };

  openConfirmRoleFormModal = (email, roleType) => {
    this.confirmRoleFormModal.openConfirmRoleFormModal(email, roleType);
    this.setState({ confirmRoleFormModal: true });
  };

  closeConfirmRoleFormModal = () => {
    this.setState({ confirmRoleFormModal: false });
  };

  openNewRoleFormModal = (email) => {
    const { role } = this.state;

    this.newRoleFormModal.openRoleFormModal(role, email);
    this.setState({ newRoleFormModal: true });
  };

  closeNewRoleFormModal = () => {
    this.setState({ newRoleFormModal: false });
  };

  openEditRoleFormModal = (data) => {
    this.editRoleFormModal.editRoleFormModal(data);
    this.setState({ editRoleFormModal: true });
  };

  closeEditRoleFormModal = () => {
    this.setState({ editRoleFormModal: false });
  };

  handleSelectChange = (field, value) => {
    this.setState({ [field]: value });
  }

  render() {
    const { loading, storeRolesPortal } = this.props.data;
    const { role, options } = this.state;

    return (
      <Content>
        <h2>Adicionar uma nova função administrativa</h2>
        <p className="subtitle">
          {'Todos que trabalham na sua loja podem ter uma função diferente, dependendo daquilo em que precisarem trabalhar.'}
        </p>
        <Row>
          <div className="row-2">
            <Label>
              <SelectLabel>
                <Select
                  className="input"
                  classNamePrefix="input"
                  placeholder="Selecione"
                  defaultValue={options[2]}
                  onChange={value => this.handleSelectChange('role', value.label)}
                  options={options}
                  isSearchable={false}
                  isClearable={false}
                />
              </SelectLabel>
              {role === 'Dono' && (
                <p className="inputMessage alertMessage">
                  <span className="errorMessage">Pode gerenciar todos os aspectos da Loja.</span>
                  {' Pode: fazer a gestão dos pedidos, cadastrar materiais, ver detalhes financeiros, visualizar e responder avaliações, alterar informações da loja e adicionar funções administrativas.'}
                </p>
              )}
              {role === 'Gerente' && <p className="inputMessage alertMessage">Pode fazer a gestão dos pedidos, cadastrar materiais, ver detalhes de faturamento, visualizar e responder avaliações, alterar informações da loja e adicionar funcionários.</p>}
              {role === 'Funcionário' && <p className="inputMessage alertMessage">Pode fazer a gestão dos pedidos, cadastrar materiais, visualizar e responder avaliações.</p>}
            </Label>
            <div style={{ flex: 1, marginLeft: '10px' }}>
              <Button type="submit" onClick={this.openVerifyRoleFormModal}>
                <span>
                  {'Adicionar'}
                </span>
              </Button>
            </div>
          </div>
          <h2>Funções administrativas existentes</h2>
          {loading ? (
            <Loading size={8} margin="1px" />
          ) : (
            <>
              {storeRolesPortal.roles.map(item => (
                <ListItem
                  key={item.id}
                  id={item.id}
                  item={item}
                  edit={this.openEditRoleFormModal}
                  user={this.props.user}
                />
              ))}
            </>
          )}
        </Row>
        <VerifyRoleFormModal
          ref={(el) => { if (el) this.verifyRoleFormModal = el.getWrappedInstance(); }}
          open={this.state.verifyRoleFormModal}
          close={this.closeVerifyRoleFormModal}
          success={this.openNewRoleFormModal}
          confirmModal={this.openConfirmRoleFormModal}
          storeId={this.props.store.id}
        />
        <ConfirmRoleFormModal
          ref={(el) => { if (el) this.confirmRoleFormModal = el.getWrappedInstance(); }}
          open={this.state.confirmRoleFormModal}
          close={this.closeConfirmRoleFormModal}
          closeVerifyModal={this.closeVerifyRoleFormModal}
          storeId={this.props.store.id}
        />
        <NewRoleFormModal
          ref={(el) => { if (el) this.newRoleFormModal = el.getWrappedInstance(); }}
          open={this.state.newRoleFormModal}
          close={this.closeNewRoleFormModal}
          storeId={this.props.store.id}
        />
        <EditRoleFormModal
          ref={(el) => { if (el) this.editRoleFormModal = el.getWrappedInstance(); }}
          open={this.state.editRoleFormModal}
          close={this.closeEditRoleFormModal}
          deleteStoreRole={this.props.deleteStoreRole}
          userType={this.props.user.roleType}
          storeId={this.props.store.id}
        />
      </Content>
    );
  }
}

export default compose(
  graphql(storeRoles, {
    options: props => ({
      variables: { storeId: props.store.id },
      fetchPolicy: 'network-only',
    }),
  }),
  graphql(deleteStoreRole, { name: 'deleteStoreRole', withRef: true }),
)(AdminRoles);
